<template>
  <div>
    <LeadViewSelect
      :selected-lead-view="leadView"
      @select-lead-view="setLeadViewSettings"
    />
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import LeadViewSelect from '@/components/organisms/user/general/leadViewSelect/LeadViewSelect.vue';
import { useDefaultLeadViewDisplayColumnsComposable } from '@/composable/user/leadList/default-lead-view-display-columns';
import { camelcaseFilterParamsKeys } from '@/composable/user/leadList/lead-filter';
import { isObject } from '@/utils/object';

export default {
  name: 'LeadViewSelectPanel',
  components: {
    LeadViewSelect,
  },
  emits: ['afterSetLeadView'],
  setup() {
    const { setDefaultDisplayColumns } = useDefaultLeadViewDisplayColumnsComposable();
    return {
      setDefaultDisplayColumns,
    };
  },
  computed: {
    ...mapGetters('user', ['leadViews', 'leadView']),
  },
  created() {
    this.getLeadViewsAction();
  },
  methods: {
    ...mapWaitingActions('user', {
      getLeadViewsAction: {
        action: 'getLeadViewsAction',
        loader: 'getLeadViewsWait',
      },
      clearLeadViewAction: 'clearLeadViewAction',
      setLeadViewAction: 'setLeadViewAction',
    }),
    ...mapWaitingActions('userUi', {
      setLeadListFilterParamsAction: 'setLeadListFilterParamsWait',
      clearLeadListFilterParamsAction: 'clearLeadListFilterParamsAction',
      setFilterControlPanelVisibleAction: 'setFilterControlPanelVisibleWait',
      setLeadListSelectedColumnsAction: 'setLeadListSelectedColumnsWait',
      setLeadListSortKeyAction: 'setLeadListSortKeyWait',
      setLeadListSortOrderAction: 'setLeadListSortOrderWait',
      clearLeadListSortKeyAction: 'clearLeadListSortKeyAction',
      clearLeadListSortOrderAction: 'clearLeadListSortOrderAction',
    }),
    async setLeadViewSettings(leadView) {
      if (!isObject(leadView) || Object.keys(leadView).length === 0) {
        await this.clearCondition();
        this.$emit('afterSetLeadView');
        return false;
      }

      const columns = this.$JSON.parse(leadView.displayColumns);
      this.setLeadListSelectedColumnsAction(columns);
      this.setLeadListSortKeyAction(leadView.sortKey);
      this.setLeadListSortOrderAction(leadView.sortOrder);
      this.setFilterParams(leadView.filterParams);
      this.setLeadViewAction(leadView);
      this.$emit('afterSetLeadView');
    },
    setFilterParams(filterParams) {
      filterParams = this.$JSON.parse(filterParams);

      if (Object.keys(filterParams).length === 0) {
        this.clearLeadListFilterParamsAction();
        this.setFilterControlPanelVisibleAction(true);
        return false;
      }
      filterParams = camelcaseFilterParamsKeys(filterParams);
      if (Object.keys(filterParams).length > 0) {
        this.setLeadListFilterParamsAction(filterParams);
        this.setFilterControlPanelVisibleAction(true);
      }
    },
    async clearCondition() {
      await this.setDefaultDisplayColumns();
      this.clearLeadListFilterParamsAction();
      this.clearLeadListSortKeyAction();
      this.clearLeadListSortOrderAction();
      this.clearLeadViewAction();
    },
  },
};
</script>
